import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import DynamicComponent from '../DynamicComponent';
import CheckoutSection from '../Checkout/utils/Checkout.Section';
import CheckoutSectionContent from '../Checkout/utils/Checkout.SectionContent';
import { translate } from '../../Services/translation';
import TextArea from '../Inputs/TextArea';
import {
    setOrderNoteForB2C,
    setB2cZipCodeAction,
    setB2CZipCode,
    setB2CZipCodeSuccess,
    acceptNewsLetterSignUpB2C as setAcceptNewsLetterSignUp
 } from '../../Actions/Checkout.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import Input from '../Inputs/Input';
import Button from '../Button';
import Checkbox from '../Inputs/Checkbox';

const scriptPattern = /<script\b[^>]*>([\s\S]*?)<\/script>/gi;
const scriptFilePattern = /<script.*?src=["'](.*?)["']/gi;

const extractScripts = (domString) => {
    let matches,
        html = domString;
    const scripts = [],
        scriptFiles = [];
    while ((matches = scriptPattern.exec(domString)) !== null) {
        html = html.replace(matches[0], '');
        matches[1] && matches[1].trim() !== '' && scripts.push(matches[1]);
    }
    while ((matches = scriptFilePattern.exec(domString)) !== null) {
        matches[1] && matches[1].trim() !== '' && scriptFiles.push(matches[1]);
    }

    return {
        html,
        scripts,
        scriptFiles,
    };
};

const executeScript = (domId, scriptContent) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    try {
        script.appendChild(document.createTextNode(scriptContent));
    } catch (e) {
        // to support IE
        script.text = scriptContent;
    }
    document.getElementById(domId).appendChild(script);
};

const includeScript = (domId, srciptUrl) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = srciptUrl;
    document.getElementById(domId).appendChild(script);
};

const PaymentWidget = React.memo(function PaymentWidget({ responseString }) {
    const dispatch = useDispatch();
    const { payload, errors = {} } = useTypedSelector((state) => state.checkout);
    var comment = payload.orderNote || '';
    const setComment = (val) => {
        comment = val;
    }
    const renderWidget = (paymentSession) => {
        const CheckoutWidget = DynamicComponent({
            loader: () => import('./CheckoutWidget'),
        });
        const args = {
            paymentSession,
            extractScripts,
            executeScript,
            includeScript,
        };
        return <CheckoutWidget {...args} />;
    };

    useEffect(() => {
        if (payload.selectedPaymentMethod?.id?.toString()?.toLowerCase() && payload.selectedPaymentMethod.id.toString().toLowerCase().includes("vipps")) {
            dispatch(setB2CZipCodeSuccess(true));
            return;
        }
        if (!payload.b2cZipCode || payload.b2cZipCode == "") {
            dispatch(setB2CZipCodeSuccess(false));
        }
    }, [payload.selectedPaymentMethod, setB2CZipCodeSuccess]);

    return (
        <CheckoutSection title={translate('checkout.confirmorder.title')}>
            <TextArea
                wrapperClassName="payment-widget-comment"
                inputSize="xlarge"
                label={translate('checkout.order.message')}
                id="additional-info__input"
                placeholder={translate('checkout.ordernote.placeholder')}
                
                defaultValue={comment}
                onChange={(e) => setComment(e.target.value)}
                onBlur={(e) => dispatch(setOrderNoteForB2C(comment))}
            />
            <Checkbox
                inputSize="large"
                id="terms-acceptnews"
                checked={payload.acceptNewsLetterSignUp}
                onChange={(e) =>
                    dispatch(setAcceptNewsLetterSignUp(e.target.checked))
                }
                inputState='default'
                label={translate(`checkout.terms.accept.news`)}
                wrapperClassName="payment-widget-news"
            />
            {payload.selectedPaymentMethod?.id?.toString()?.toLowerCase() && payload.selectedPaymentMethod.id.toString().toLowerCase().includes("vipps") ? <></> :
              <CheckoutSectionContent className="payment-widget-zip-container">
                {payload.b2cZipCodeCorrect
                    ?
                    <>
                        <p className="b2CZipCode">{translate('checkout.b2czipcode.selected')}<b>{payload.b2cZipCode}</b></p>
                        <Button
                            btnType="primary"
                            onClick={() => dispatch(setB2CZipCodeSuccess(false))}
                        >
                            {translate('checkout.b2czipcode.change')}
                        </Button>
                    </>
                    :
                    <>
                        <Input
                            wrapperClassName="b2CZipCode"
                            id="B2CZipCode"
                            type="number"
                            onChange={(e) => dispatch(setB2CZipCode(e.target.value))}
                            value={payload.b2cZipCode || ''}
                            label={translate('checkout.b2czipcode.label')}
                            placeholder={translate('checkout.b2czipcode.placeholder')}
                            message={
                                errors['general']?.length > 0
                                    ? errors['general'][0]
                                    : null
                            }
                            inputState={
                                errors['general']?.length > 0 ? 'error' : 'default'
                            }
                        />
                        <Button
                            btnType="primary"
                            onClick={() => dispatch(setB2cZipCodeAction())}
                        >
                            {translate('checkout.b2czipcode.set')}
                        </Button>
                    </>
                }
              </CheckoutSectionContent>}
            <CheckoutSectionContent>
                {payload.b2cZipCodeCorrect && renderWidget(responseString)}
            </CheckoutSectionContent>
        </CheckoutSection>
    );
});

export default PaymentWidget;
